import { useTranslation } from 'react-i18next';
import { Col, Divider, Row, Table } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import Filters from 'components/filters';
import { Button, PageHeader } from 'components';
import { ExcelIcon } from 'icons';

import { useSalesTracking } from '../useSalesTracking';
import styles from './style.module.scss';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../hooks/useUser';

const MainPage = () => {
  const { t } = useTranslation();
  const {
    handleCloseFilter,
    handleChangeFilters,
    filters,
    columns,
    data,
    loading,
    onChangeTableFilter,
    handleDownloadExcel,
  } = useSalesTracking();

  const pages = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={t('SALES TRACKING').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters
          onClose={handleCloseFilter}
          onChange={handleChangeFilters}
          filters={filters}
        />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.salesTracking}
          pagination={data.pagination}
          scroll={{ x: 1200 }}
          loading={loading}
          onChange={onChangeTableFilter}
        />
      </div>
    </>
  );
};

export default MainPage;
